module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-properties-90f0bd93d7ec20b2cd2880db5feb154d.svg";